// HowWaveLightWorks.jsx
import React from "react";
import { Box, Grid, Typography } from "@mui/material";

/*
 Replace these with your actual image paths in assets
  - machineImage: the big machine image (right side)
  - watermark: faint hexagon/medical pattern used behind content (optional)
*/
import machineImage from "assets/images/wavelight/machine.png";
import watermark from "assets/images/wavelight/hexagon-watermark.png";

const HowWaveLightWorks = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { md: 18, xs: 12 },
        px: { md: 14, xs: 3 },
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#fff",
        backgroundImage: `url(${watermark})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
      }}
    >
      {/* subtle watermark on the whole section (optional) */}
     
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Left text column */}
        <Grid item xs={12} md={6}>
          <Box sx={{ maxWidth: 680 }}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { md: "28px", xs: "20px" },
                letterSpacing: 0.2,
              }}
            >
              HOW WAVELIGHT® PLUS WORKS
            </Typography>

            <Typography
              sx={{
                mt: 2,
                fontWeight: 600,
                fontSize: { md: "13px", xs: "12px" },
                color: "#333",
              }}
            >
              100% SAFE, U.S. FDA APPROVED
            </Typography>

            <Typography
              sx={{
                mt: 2.5,
                fontSize: { md: "15px", xs: "14px" },
                color: "#666",
                lineHeight: 1.9,
              }}
            >
              WaveLight® Plus uses advanced, AI-guided laser technology to create a
              fully customized treatment plan for your unique eyes. By mapping the
              entire optical system with ultra-precise 3D imaging, it reshapes the
              cornea in seconds — all without blades, stitches, or pain.
            </Typography>
          </Box>
        </Grid>

        {/* Right image column */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: { md: "flex-end", xs: "center" },
            alignItems: "center",
            position: "relative",
          }}
        >
          <Box
            component="img"
            src={machineImage}
            alt="WaveLight Machine"
            sx={{
              width: { md: "520px", sm: "420px", xs: "320px" },
              height: "auto",
              display: "block",
              filter: "drop-shadow(0px 10px 30px rgba(0,0,0,0.12))",
              transform: { md: "translateY(0)", xs: "translateY(0)" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HowWaveLightWorks;
